export enum RecordingObjectionScope {
  Today = 'today',
  Permanent = 'permanent',
}

export type RecordingObjectionStatus = {
  active: boolean;
  scope: RecordingObjectionScope | null;
  objectedOn: string | null;
};
